import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITrackingEvent } from "src/pages/Studies/models/interfaces";

interface UserActivityState {
	userActivityData: ITrackingEvent[];
}

export const initialState: UserActivityState = {
	userActivityData: [],
};

const userActivitySlice = createSlice({
	name: "userActivity",
	initialState,
	reducers: {
		updateUserActivityData: (state, action: PayloadAction<ITrackingEvent>) => {
			state.userActivityData = [...state.userActivityData, action.payload];
		},
		clearUserActivityData: (state) => {
			state.userActivityData = [];
		},
	},
});

export const { updateUserActivityData, clearUserActivityData } = userActivitySlice.actions;

export default userActivitySlice.reducer;
